import { Link } from 'react-router-dom';

const AboutPreview = () => {
  return (
    <section className="py-16 sm:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-gray-900 mb-4 sm:mb-6">
            Heritage Meets Ambition
          </h2>
          <p className="text-base sm:text-xl text-gray-600 max-w-3xl mx-auto">
            From traditional roots to an <strong>AI-powered business conglomerate</strong> — where legacy fuels innovation
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          <div className="w-full h-64 sm:h-96">
            <img
              src="https://public.readdy.ai/ai/img_res/62914e9ec6f45a0a2f29e79d913745e2.jpg"
              alt="Drixem Venture Malaysian Heritage"
              className="w-full h-full object-cover object-top rounded-2xl shadow-xl"
            />
          </div>

          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                <i className="ri-calendar-line text-2xl text-primary-600" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Established Since 1996
                </h3>
                <p className="text-gray-600">
                  Our journey began with <strong>Heuliez (M) Sdn Bhd</strong>,
                  established in 1996 — nearly three decades of proven business excellence that forms the bedrock of investor confidence.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                <i className="ri-award-line text-2xl text-primary-600" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  MSC Status Since 2006
                </h3>
                <p className="text-gray-600">
                  <strong>Drixem Sdn Bhd</strong> received its MSC Status Company
                  award in 2006, unlocking government-backed technology incentives and positioning us at the forefront of digital innovation.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0">
                <i className="ri-robot-line text-2xl text-accent-600" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Physical AI — Our Core
                </h3>
                <p className="text-gray-600">
                  <strong>Physical AI</strong> is the core of our business operations — integrating AI with hardware, logistics, and industrial infrastructure at massive scale. A field proven by industry leaders like <strong>Nvidia</strong> and <strong>Amazon</strong>, now applied across all Drixem Group divisions.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                <i className="ri-stock-line text-2xl text-primary-600" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Our Vision: Public Listing
                </h3>
                <p className="text-gray-600">
                  Our ultimate goal is <strong>public listing on one or more of our subsidiaries</strong> while maintaining Drixem Group as a private company — delivering world-class governance and exceptional investor returns.
                </p>
              </div>
            </div>

            <div className="pt-6">
              <p className="text-xl sm:text-2xl font-display font-semibold text-primary-600 mb-6 italic">
                &ldquo;We Create Our Own Destiny&rdquo;
              </p>
              <Link
                to="/about"
                className="inline-flex items-center space-x-2 text-primary-600 hover:text-primary-700 font-semibold transition-colors"
                aria-label="Learn more about our journey"
              >
                <span>Discover Our Story</span>
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>

        {/* Connected Network: Mills & Refineries */}
        <div className="mt-16 sm:mt-24">
          <div className="text-center mb-8 sm:mb-12">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary-50 rounded-full mb-6">
              <i className="ri-links-line text-primary-600"></i>
              <span className="text-sm text-primary-700 font-medium">Connected Network</span>
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-gray-900 mb-4 sm:mb-6">
              Mills &amp; Refineries Network
            </h2>
            <p className="text-base sm:text-xl text-gray-600 max-w-3xl mx-auto">
              Connecting palm oil <strong>mills and refineries across Malaysia and Indonesia</strong> in one integrated supply chain hub
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-xl transition-all">
              <div className="w-full h-56">
                <img
                  src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20multiple%20palm%20oil%20mills%20and%20refinery%20facilities%20connected%20by%20roads%20in%20Malaysian%20tropical%20landscape%20with%20lush%20green%20palm%20plantations%20surrounding%20the%20industrial%20complex%20bright%20sunny%20day%20professional%20aerial%20industrial%20photography&width=800&height=400&seq=network-malaysia-mills-v1&orientation=landscape"
                  alt="Malaysia Mills Network"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg">
                    <i className="ri-flag-line text-xl text-primary-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">Malaysia Network</h3>
                </div>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Strategic partnerships with palm oil mills and refineries across <strong>Johor, Negeri Sembilan, Pahang, and Sabah</strong> — ensuring consistent supply and quality control from plantation to export.
                </p>
                <ul className="space-y-2">
                  <li className="flex items-center space-x-2">
                    <div className="w-5 h-5 flex items-center justify-center"><i className="ri-check-line text-primary-600"></i></div>
                    <span className="text-sm text-gray-700">MPOB Licensed Mills</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <div className="w-5 h-5 flex items-center justify-center"><i className="ri-check-line text-primary-600"></i></div>
                    <span className="text-sm text-gray-700">JAKIM Halal Certified Refineries</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <div className="w-5 h-5 flex items-center justify-center"><i className="ri-check-line text-primary-600"></i></div>
                    <span className="text-sm text-gray-700">Integrated Logistics &amp; Storage</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-xl transition-all">
              <div className="w-full h-56">
                <img
                  src="https://readdy.ai/api/search-image?query=Large%20palm%20oil%20refinery%20and%20processing%20plant%20in%20Indonesian%20tropical%20setting%20with%20storage%20tanks%20and%20processing%20towers%20surrounded%20by%20vast%20palm%20oil%20plantation%20Sumatra%20or%20Kalimantan%20Indonesia%20bright%20tropical%20day%20professional%20industrial%20photography&width=800&height=400&seq=network-indonesia-mills-v1&orientation=landscape"
                  alt="Indonesia Mills Network"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg">
                    <i className="ri-flag-line text-xl text-accent-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">Indonesia Network</h3>
                </div>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Expanding our reach into <strong>Sumatra and Kalimantan</strong> — the world&apos;s largest palm oil producing regions — to secure competitive pricing and diversified sourcing.
                </p>
                <ul className="space-y-2">
                  <li className="flex items-center space-x-2">
                    <div className="w-5 h-5 flex items-center justify-center"><i className="ri-check-line text-accent-600"></i></div>
                    <span className="text-sm text-gray-700">Sumatra &amp; Kalimantan Partners</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <div className="w-5 h-5 flex items-center justify-center"><i className="ri-check-line text-accent-600"></i></div>
                    <span className="text-sm text-gray-700">Cross-Border Trade Facilitation</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <div className="w-5 h-5 flex items-center justify-center"><i className="ri-check-line text-accent-600"></i></div>
                    <span className="text-sm text-gray-700">Sustainable Sourcing Standards</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
